import { NgModule } from 'angular-ts-decorators';
import { moduleName } from './constants';

import { HeroCustomizerV3Component } from './hero-customizer-v3.component';

import { CustomizerV3ApiService } from './customizer-v3-api.service';
import { GiftWrappingApiService } from './gift-wrapping-api.service';

import { HeroCustomizerV3AccessoriesModule } from './accessories/module';
import { HeroCustomizerV3EngravingModule } from './engraving/module';
import { HeroCustomizerV3FilteringModule } from './filtering/module';
import { HeroCustomizerV3ImageGalleryModule } from './image-gallery/module';
import { HeroCustomizerV3TotalsModule } from './totals/module';
import { HeroCustomizerV3GiftWrappingModule } from './gift-wrapping/module';

@NgModule({
  declarations: [HeroCustomizerV3Component],
  id: moduleName,
  imports: [
    HeroCustomizerV3GiftWrappingModule,
    HeroCustomizerV3ImageGalleryModule,
    HeroCustomizerV3FilteringModule,
    HeroCustomizerV3AccessoriesModule,
    HeroCustomizerV3TotalsModule,
    HeroCustomizerV3EngravingModule,
  ],
  providers: [
    CustomizerV3ApiService,
    GiftWrappingApiService
  ],
})
export class HeroCustomizerV3Module {
}
